import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import {
  getFirestore,
  createFirestoreInstance,
  reduxFirestore,
} from "redux-firestore";
import { getFirebase } from "react-redux-firebase";
import fbConfig from "../config/fb-config";
import { rootReducer } from "./root-reducer";

const store = createStore(
  rootReducer,
  compose(
    applyMiddleware(thunk.withExtraArgument({ getFirebase, getFirestore })),
    reduxFirestore(fbConfig),
  )
);

export default store;

export const rrfProps = {
  firebase: fbConfig,
  dispatch: store.dispatch,
  config: {
    enableLogging: false,
    useFirestoreForProfile: true,
    userProfile: "users-profile",
  },
  createFirestoreInstance,
}
